import { Component, Inject, OnInit } from '@angular/core';
import { MatButtonToggleChange } from '@angular/material/button-toggle';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ErrorReportService } from 'src/services/error-report.service';
import { HttpService } from 'src/services/http.service';
import { ProcessListInterviewDialogComponent } from '../process-list-interview-dialog/process-list-interview-dialog.component';
import { ProcessListInterviewSessionDialogComponent } from '../process-list-interview-session-dialog/process-list-interview-session-dialog.component';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-process-list-interview-evaluated-dialog',
  templateUrl: './process-list-interview-evaluated-dialog.component.html',
  styleUrls: ['./process-list-interview-evaluated-dialog.component.scss']
})
export class ProcessListInterviewEvaluatedDialogComponent implements OnInit {

  candidateId: string;
  candidateStatus: string;
  processList: any;
  formsMap = new Map<string, FormGroup>(); // Map para armazenar formulários por ID de entrevista
  interviews: any[] = []; // Lista de entrevistas

  constructor(
    @Inject(MAT_DIALOG_DATA) data: any,
    private http: HttpService,
    private errorReport: ErrorReportService,
    private dialogRef: MatDialogRef<ProcessListInterviewEvaluatedDialogComponent>,
    private snackbar: MatSnackBar,
    private dialog: MatDialog,
    private fb: FormBuilder,
  ) { 
    this.candidateId = data.candidate.id;
    this.candidateStatus = data.candidate.candidateStatus;
    this.processList = data.processList;
  }

  ngOnInit(): void {
    this.getInterview();
  }

  getInterview() {

    const params = {
      userId: this.candidateId,
      processList: this.processList.id
    }
    this.http.get('user_process_list:interview', params)
      .subscribe(
        (result: any) => {
          if(result.type === 'OK') {
            
            if(result.data){
              this.interviews = result.data;
              this.initializeForms();
              this.onChangeViewForAll();
            }else {
              this.dialogRef.close();
              this.snackbar.open('Entrevista ainda não foi agendada', 'OK', { duration: 3000 });
            }
          }
        },
        err => this.errorReport.showMessage(err)
      );

  }

  onChangePoints(event: MatButtonToggleChange, interview) {

    const { value } = event;
    const params = {
      userId: this.candidateId,
      interview: interview.id,
      points: value
    }
    this.http.save('user_process_list:interview_points', params)
      .subscribe(
        (result: any) => {
          if(result.type === 'OK') {
            this.snackbar.open('Pontuação salva com suceso!', 'OK', { duration: 3000 })
            this.getInterview();
          }
        },
        err => this.errorReport.showMessage(err)
      )
    
  }

  onChangeViewForAll() {
    if (this.interviews && this.interviews.length > 0) {
      const interviewIds = this.interviews.map((interview: any) => interview.id);
  
      const params = {
        userId: this.candidateId,
        interviews: JSON.stringify(interviewIds), // Enviar array de IDs
        view: 1
      };
  
      this.http.save('user_process_list:interview_views', params)
        .subscribe(
          (result: any) => {
          },
          err => this.errorReport.showMessage(err)
        );
    }
  }

  openInterview() {

    const options = {
      width: '900px',
      disableClose: true,
      data: {
        processListId: this.processList.id,
        currentProcessList: this.processList
      }
    }
    this.dialog.open(ProcessListInterviewDialogComponent, options);

  }

  openInterviewSession() {
  
    const options = {
      disableClose: true,
      width: '900px',
      data: {
        processListId: this.processList.id,
        processList: this.processList
      }
    }
    this.dialog.open(ProcessListInterviewSessionDialogComponent, options)

  }

  initializeForms() {
    this.interviews.forEach((interview) => {
      const form = this.fb.group({
        observacao: [interview.observacao || '', [Validators.maxLength(1000)]],
      });
      this.formsMap.set(interview.id, form);
    });
  }

  submit(interview) {
    const form = this.formsMap.get(interview.id);
    if (form && form.valid) {
      const data = form.value;
      data.id = interview.id;
      data.lead = interview.lead;

      this.http.save('user_process_list:interview_observation', data).subscribe(
        (result: any) => {
          if (result.type === 'OK') {
            this.snackbar.open('Observação salva com sucesso!', 'OK', { duration: 3000 });
          } else {
            this.snackbar.open('Ocorreu um erro, tente novamente mais tarde.', 'OK', { duration: 3000 });
          }
        },
        (err) => this.errorReport.showMessage(err)
      );
    }
  }

  formatTime(time: string): string {
    return time.substring(0, 5); // Retorna apenas os primeiros 5 caracteres (HH:mm)
  }

}
